import axios from 'axios';
import config from '../config';

class TableBookingApi {
  static getBookingConfig(restaurantCode) {
    return axios
      .get(`${config.fooditUrl}/api/v5/booking/restaurant/${restaurantCode}/configuration.json`)
      .then(res => res.data);
  }

  static submit(restaurantCode, restaurantId, date, values) {
    const url = `${config.fooditUrl}/api/v5/booking/restaurant/${restaurantCode}/create`;
    const data = {
      restaurantIdNumber: restaurantId,
      externalWebsite: false,
      guests: values.guests,
      time: values.time,
      reservationName: values.name,
      email: values.email,
      phone: values.phone,
      date
    };
    return axios.post(url, data)
      .then(res => {
        if (Array.isArray(res.data)) {  //TODO: change this when the new api is ready
          throw res.data;
        } else {
          return res.data;
        }
      });
  }
}

export default TableBookingApi;



// WEBPACK FOOTER //
// ./api/tableBooking.api.js